import * as React from "react";
import { useContext } from "react";
import FormWarningsProvider from "contexts/FormWarningsProvider";
import StreamsContext from "contexts/StreamsContext";
import FilterAggregationForm from "./FilterAggregationForm";
const FilterAggregationFormContainer = (props) => {
  const streams = useContext(StreamsContext);
  return /* @__PURE__ */ React.createElement(FormWarningsProvider, null, /* @__PURE__ */ React.createElement(FilterAggregationForm, { streams, ...props }));
};
export default FilterAggregationFormContainer;
